import { Input } from "antd";
import * as React from "react";
import Text from "../text";

interface Handles {
  focus: () => void;
}

interface IProps {
  value: string;
  id: string;
  label?: string;
  icon?: React.ReactNode;
  placeholder?: string;
  className?: string;
  required?: boolean;
  multiline?: boolean;
  readOnly?: boolean;
  inlineLabel?: boolean;
  autoFocus?: boolean;
  numberOfLines?: number;
  addonBefore?: React.ReactNode;
  backgroundColor?: string;
  type?: "text" | "password" | "email" | "number" | "tel" | "date";
  error?: string;
  disabled?: boolean;
  onChange?: (value: string) => void;
  onBlur?: () => void;
}

const Textbox = React.forwardRef<Handles, IProps>(
  (
    {
      id,
      label,
      value = "",
      icon,
      multiline = false,
      type = "text",
      className,
      placeholder = " ",
      numberOfLines = 4,
      addonBefore,
      error,
      readOnly = false,
      inlineLabel = true,
      backgroundColor = "bg-white",
      autoFocus = false,
      required = false,
      disabled = false,
      onChange,
      onBlur,
    }: IProps,
    ref
  ) => {
    const inputRef = React.useRef<any>(null);

    React.useImperativeHandle(ref, () => ({
      focus: () => {
        inputRef.current?.focus();
      },
    }));

    return (
      <div className="flex flex-col flex-1">
        {label && !inlineLabel && (
          <label
            htmlFor={id}
            className={`mb-1 text-12 font-semibold 
              text-black/60
              `}
          >
            {label}
          </label>
        )}
        <div
          className={`flex flex-1 relative border border-grey3 rounded-md overflow-hidden  ${backgroundColor} ${
            error && "!border-red"
          }`}
        >
          {icon && <div className="flex items-center ml-3 w-6 ">{icon}</div>}
          <div className="flex flex-col flex-1 relative">
            {multiline ? (
              <textarea
                id={id}
                readOnly={readOnly}
                ref={inputRef}
                rows={numberOfLines}
                name={id}
                onBlur={onBlur}
                disabled={disabled}
                placeholder={placeholder}
                required={required}
                autoFocus={autoFocus}
                value={value || ""}
                onChange={(e) => {
                  if (onChange) onChange(e.target.value);
                }}
                className={`${className} disabled:bg-grey focus:border-none focus:ring-0 focus:ring-offset-0 appearance-none block w-full peer px-3 ${
                  label && inlineLabel ? "!pt-[18px] !pb-[6px]" : "py-2"
                } !border-none bg-transparent`}
              />
            ) : (
              <div className="flex items-center">
                {/* <Input
                  id={id}
                  ref={inputRef}
                  readOnly={readOnly}
                  name={id}
                  addonBefore={addonBefore}
                  type={type}
                  disabled={disabled}
                  bordered={false}
                  placeholder={placeholder}
                  required={required}
                  autoFocus={autoFocus}
                  rootClassName="bg-red"
                  value={value || ""}
                  onChange={(e) => {
                    if (onChange) onChange(e.target.value);
                  }}
                  className={`${className} [&_.ant-input-group-addon]:!border-none [&_.ant-input-group-addon]:!border-r [&_.ant-input-group-addon]:!border-e  [&_input:focus]:!shadow-none [&_input]:!border-none disabled:bg-grey focus:border-none focus:ring-0 focus:ring-offset-0 appearance-none block w-full peer ${
                    icon ? "!pr-3 !pl-[15px]" : ""
                  } ${
                    label ? "text-15 !pt-[24px] !pb-[10px] !pl-[16px " : ""
                  } !border-none bg-transparent`}
                /> */}
                {addonBefore && (
                  <div className="px-2 flex h-full items-center text-15 grow border-r bg-grey border-grey3">
                    {addonBefore}
                  </div>
                )}
                <input
                  id={id}
                  ref={inputRef}
                  readOnly={readOnly}
                  name={id}
                  onBlur={onBlur}
                  type={type}
                  disabled={disabled}
                  placeholder={placeholder}
                  required={required}
                  autoFocus={autoFocus}
                  value={value || ""}
                  onChange={(e) => {
                    if (onChange) onChange(e.target.value);
                  }}
                  className={`${className} disabled:bg-grey focus:border-none focus:ring-0 focus:ring-offset-0 appearance-none block w-full peer ${
                    icon ? "!pr-3 !pl-[15px]" : "px-3"
                  } ${
                    label && inlineLabel
                      ? "text-15 !pt-[24px] !pb-[10px] !pl-[16px]"
                      : "py-2"
                  } !border-none bg-transparent min-h-[45px]`}
                />
              </div>
            )}
            {label && inlineLabel && (
              <label
                htmlFor={id}
                className={`
              absolute text-16 font-semibold text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-3 translate-x-[2px] scale-75 top-[17px] z-10 origin-[0] left-3.5 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-3
              peer-focus:translate-x-[2px]
              text-black/80
              peer-focus:text-black/80
              peer-placeholder-shown:text-grey4
              `}
              >
                {label}
              </label>
            )}
          </div>
        </div>
        {error && (
          <div className="pt-1 pb-1">
            <Text size={11} color="red">
              {error}
            </Text>
          </div>
        )}
      </div>
    );
  }
);

export default Textbox;
